import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.form = this.element.matches('form') ? this.element : this.element.querySelector('form');

    if (!this.form) return;

    this.form.addEventListener('invalid', this.markInvalid, true);
    this.form.addEventListener('input', this.syncValidity, true);
    this.form.addEventListener('change', this.syncValidity, true);
  }

  disconnect() {
    if (!this.form) return;

    this.form.removeEventListener('invalid', this.markInvalid, true);
    this.form.removeEventListener('input', this.syncValidity, true);
    this.form.removeEventListener('change', this.syncValidity, true);
  }

  markInvalid = (event) => {
    if (!this.isValidatableField(event.target) || event.target.form !== this.form) return;

    this.markAllInvalidFields();
  };

  markAllInvalidFields() {
    if (this.isMarkingInvalidFields) return;

    this.isMarkingInvalidFields = true;

    this.form.querySelectorAll('input, select, textarea').forEach((field) => {
      if (this.isValidatableField(field) && !field.validity.valid) {
        field.setAttribute('aria-invalid', 'true');
      }
    });

    requestAnimationFrame(() => {
      this.isMarkingInvalidFields = false;
    });
  }

  syncValidity = (event) => {
    if (!this.isValidatableField(event.target) || event.target.form !== this.form) return;

    if (event.target.validity.valid) {
      event.target.removeAttribute('aria-invalid');
    } else {
      event.target.setAttribute('aria-invalid', 'true');
    }
  };

  isValidatableField(field) {
    return field.matches('input, select, textarea') && !field.disabled;
  }
}
